import { ProductBranch } from "@/types/globalTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ProductBranchSlice = {
  _id: string;
  id: string;
  nameEN: string;
  nameAR: string;
  address?: string;
  phone?: string;
  open?: boolean;
  availability?:number
};

type ProductBranchState = {
  branch: ProductBranch | null;
};

const loadBranchFromLocalStorage = (): ProductBranch | null => {
  const storedBranch = localStorage.getItem("branch");
  return storedBranch ? JSON.parse(storedBranch) : null;
};

const initialState: ProductBranchState = {
  branch: loadBranchFromLocalStorage(),
};

const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {
    setBranch: (state, action: PayloadAction<ProductBranch>) => {
      state.branch = action.payload;
      localStorage.setItem("branch", JSON.stringify(action.payload));
    },
    clearBranch: (state) => {
      state.branch = null;
      localStorage.removeItem("branch");
    },
  },
});

export const { setBranch, clearBranch } = branchSlice.actions;
export default branchSlice.reducer;
